import { render, staticRenderFns } from "./DeprecationNotice.vue?vue&type=template&id=61e10fd3"
import script from "./DeprecationNotice.vue?vue&type=script&lang=js"
export * from "./DeprecationNotice.vue?vue&type=script&lang=js"
import style0 from "./DeprecationNotice.vue?vue&type=style&index=0&id=61e10fd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports